import { Module, MutationTree, GetterTree, ActionTree } from 'vuex'
import { RootState } from '@/store'
export interface APPState {
  menustatus: boolean
  language: string
  settingdata: any
  loading: boolean
  timeoutalert: boolean
  option: any
  optionObjectType: any
  country: any
  locale: object
}

const state: APPState = {
  menustatus: false,
  language: '',
  settingdata: [],
  loading: false,
  timeoutalert: false,
  option: {},
  optionObjectType: {},
  country: [],
  locale: {}
}

export enum AppGettersTypes {
  MENU_STATUS = 'MENU_STATUS',
  GET_LANG = 'GET_LANG',
  GET_SETTING_DATA = 'GET_SETTING_DATA',
  GET_COUNTRY = 'GET_COUNTRY',
  GET_LOADING_STATUS = 'GET_LOADING_STATUS',
  GET_OPTION = 'GET_OPTION',
  GET_OPTION_OBJECT_TYPE = 'GET_OPTION_OBJECT_TYPE',
  GET_LOCALE = 'GET_LOCALE'
}

export const getters: GetterTree<APPState, RootState> = {
  [AppGettersTypes.GET_LOADING_STATUS]: (state: APPState): boolean => {
    return state.loading
  },
  [AppGettersTypes.MENU_STATUS]: (state: APPState): boolean | undefined => {
    return state.menustatus
  },
  [AppGettersTypes.GET_LANG]: (state: APPState): string => {
    return state.language
  },
  [AppGettersTypes.GET_SETTING_DATA]: (state: APPState): string | undefined => {
    return state.settingdata
  },
  [AppGettersTypes.GET_COUNTRY]: (state: APPState): string | undefined => {
    return state.country
  },
  [AppGettersTypes.GET_OPTION]: (state: APPState): any => {
    return state.option
  },
  [AppGettersTypes.GET_OPTION_OBJECT_TYPE]: (state: APPState): any => {
    return state.optionObjectType
  },
  [AppGettersTypes.GET_LOCALE]: (state: APPState): object => {
    return state.locale
  }
}

export enum AppMutationTypes {
  SET_ISLOADING = 'SET_ISLOADING',
  SET_MENU_STATUS = 'SET_MENU_STATUS',
  SET_LANG = 'SET_LANG',
  SET_SETTING_DATA = 'SET_SETTING_DATA',
  SET_MERCHANT_DATA = 'SET_MERCHANT_DATA',
  SET_CITY_DATA = 'SET_CITY_DATA',
  SET_OPTION = 'SET_OPTION',
  SET_OPTION_OBJECT_TYPE = 'SET_OPTION_OBJECT_TYPE',
  SET_COUNTRY = 'SET_COUNTRY',
  SET_LOCALE = 'SET_LOCALE'
}

export const mutations: MutationTree<APPState> = {
  [AppMutationTypes.SET_ISLOADING] (state: APPState, payload: boolean) {
    state.loading = payload
  },
  [AppMutationTypes.SET_LANG] (state: APPState, payload: string): void {
    state.language = payload
  },
  [AppMutationTypes.SET_MENU_STATUS] (state: APPState, payload: APPState): void {
    state.menustatus = payload.menustatus
  },
  [AppMutationTypes.SET_SETTING_DATA] (
    state: APPState,
    payload: APPState
  ): void {
    state.settingdata = payload
  },
  [AppMutationTypes.SET_CITY_DATA] (state: APPState, payload: APPState): void {
    state.settingdata.city = payload
  },
  [AppMutationTypes.SET_MERCHANT_DATA] (
    state: APPState,
    payload: APPState
  ): void {
    state.settingdata.Merchant = payload
  },
  [AppMutationTypes.SET_OPTION] (state: APPState, payload: any): void {
    state.option = payload
  },
  [AppMutationTypes.SET_OPTION_OBJECT_TYPE] (
    state: APPState,
    payload: any
  ): void {
    state.optionObjectType = payload
  },
  [AppMutationTypes.SET_COUNTRY] (state: APPState, payload: any): void {
    state.country = payload
  },
  [AppMutationTypes.SET_LOCALE] (state: APPState, payload: object): void {
    state.locale = payload
  }
}

export enum AppActionsTypes {
  DO_LOGIN = 'DO_LOGIN'
}
export const actions: ActionTree<APPState, RootState> = {
  [AppActionsTypes.DO_LOGIN] ({ commit }, payload: string) {
    // todo
  }
}

export const app: Module<APPState, RootState> = { state, getters, mutations }
